"use strict"

import { getAuthInstance } from "@hylable/auth"

const SOFTWARE_TOKEN_MFA = "SOFTWARE_TOKEN_MFA"

export default {
  async getLoginUser(){
    const loginUser = await getAuthInstance().getCurrentUserInfo()
    return loginUser
  },
  getLogininfo(user){
    if(!user) return {}
    const loginName = user.loginName
    const orgName = user.organizationName
    const oid = user.oid
    const type = user.type
    const username = `${user.oid}/${user.memberId}`
    return {loginName, orgName, username, oid, type}
  },
  async isMfaConfigured(){
    const preferred = (await getAuthInstance().getCurrentUserInfo()).preferredMfa
    return preferred === "TOTP"
  },
  async signIn(username, password){
    const [loginName, organizationName] = username.split("@")
    const output = await getAuthInstance().login(organizationName, loginName, password)
    if(!output.isSignedIn) {
      if (output.nextStep && output.nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_TOTP_CODE"){
        return { challengeName: SOFTWARE_TOKEN_MFA }
      }
      return {}
    }
    const user = await this.getLoginUser()
    return user
  },
  async signInWithAuthBroker(){
    return await getAuthInstance().loginWithAuthBroker()
  },
  async signInByToken(username, ltik){
    await getAuthInstance().loginByLtik(username, ltik)
    return await this.getLoginUser()
  },
  async signOut(){
    await getAuthInstance().logout()
    return 
  },
  async getTotpSecret(){
    const secretCode = await getAuthInstance().getTotpSecret()
    return secretCode
  },
  async setupTotpAuth(token){
    await getAuthInstance().setupTotpAuth(token)
  },
  async unsetMfa() {
    await getAuthInstance().unsetMfa()
  },
  async confirmTotp(token){
    await getAuthInstance().confirmSignIn({ challengeResponse: token })
  },
}
